'use client';

import type { FC } from 'react';
import { ScreenContent, ScreenFixedBottom, ScreenDisableSafeArea } from '../../screen';
import { Title, Skeleton, ButtonGroup } from '../../components/ui';
import { ItemGridSkeleton } from '../../components/ItemGridSkeleton';
import { useLocalTranslation } from '../../hooks/useLocalTranslation';
import translations from './CaseDetailsScreen.translations';

export const CaseDetailsScreenSkeleton: FC = () => {
  const { t } = useLocalTranslation(translations);

  return (
    <>
      <ScreenDisableSafeArea />
      <ScreenFixedBottom>
        <ButtonGroup>
          <div className="flex justify-center">
            <Skeleton className="h-6 w-40 rounded-full" />
          </div>

          <Skeleton className="h-[54px] w-full rounded-2xl" />
          <Skeleton className="h-[50px] w-full rounded-full" />
        </ButtonGroup>
      </ScreenFixedBottom>
      <ScreenContent>
        <div className="flex flex-col gap-6 pb-4">
          <div className="relative w-full">
            <Skeleton className="w-full aspect-square rounded-none" />
            <div className="absolute bottom-0 start-0 end-0 z-[1] flex flex-col items-center gap-1 p-3">
              <Skeleton className="h-10 w-52 rounded-full" />
              <div className="flex flex-row items-center gap-2">
                <Skeleton className="h-7 w-24 rounded-full" />
                <Skeleton className="h-7 w-20 rounded-full" />
              </div>
            </div>
          </div>

          <div className="flex flex-col gap-4">
            <Title level="2" className="m-0 text-center text-lg font-semibold text-white">
              {t('itemsInCase')}
            </Title>
            <ItemGridSkeleton count={8} />
          </div>
        </div>
      </ScreenContent>
    </>
  );
};
